export class ExchangeRateOverridesArgument {
  longId: number;
  currencyId: number;
  factor: number;
  validUntil: string;
}